import React, { memo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, Col } from 'components/layout';
import { TextArea } from 'components/form';
import { GamificationProps } from 'pages/company/Gamification';
import SectionWrapper from '../SectionWrapper';
import styles from '../SocietyProfileDetails/SocietyProfileDetails.module.scss';

export interface AboutProps extends GamificationProps {
  showProgressBanner: boolean;
  setIsAboutCompleted: React.Dispatch<React.SetStateAction<boolean>>;
}

export const About: React.FC<AboutProps> = memo(
  ({
    progressDetails,
    profileCompletePercent,
    nonCompletedSection,
    showProgressBanner,
    handleProfileCompletionButton,
    handleNextButton,
    showNextButton,
    setIsAboutCompleted,
  }: AboutProps) => {
    const {
      register,
      formState: { errors },
      watch,
    } = useFormContext(); // retrieve all hook methods

    const editedDescription = watch('description');
    const editedShortDescription = watch('short_description');

    useEffect(() => {
      setIsAboutCompleted(
        editedDescription && editedShortDescription ? true : false
      );
    }, [editedDescription, editedShortDescription]);

    return (
      <div id={`section_${progressDetails?.id}`}>
        <SectionWrapper
          title="About"
          description="Add a tagline and a broader description about your society."
          progressDetails={progressDetails}
          profileCompletePercent={profileCompletePercent}
          nonCompletedSection={nonCompletedSection}
          handleProfileCompletionButton={handleProfileCompletionButton}
          handleNextButton={handleNextButton}
          showNextButton={showNextButton}
          showProgressBanner={showProgressBanner}
        >
          <Row className={styles.SocietyProfileDetailsFormRow}>
            <Col span={24} className={styles.shortDescription}>
              <TextArea
                rows={4}
                label="Tagline"
                placeholder="Bringing entrepreneurship to the masses, one student at a time. 🚀"
                {...register('short_description', {
                  required: 'Tagline is required',
                })}
                isValid={!errors.short_description}
                helperText={errors.short_description?.message}
                labelClassName={styles.labelField}
                textAreaClassName={styles.textArea}
                maxLength={120}
              />
            </Col>
            <Col span={24}>
              <TextArea
                rows={4}
                label="About your Society"
                {...register('description', {
                  required: 'Description is required',
                })}
                isValid={!errors.description}
                helperText={errors.description?.message}
                labelClassName={styles.labelField}
                textAreaClassName={styles.textArea}
                maxLength={1600}
              />
            </Col>
          </Row>
        </SectionWrapper>
      </div>
    );
  }
);

About.displayName = 'About';
